import React, { useState, useEffect } from "react";
//import { confirm } from "react-confirm-box";
import axios from 'axios';
import {Link, NavLink } from "react-router-dom";
import { useLocation } from "react-router";
import $ from 'jquery';

import { useNavigate } from 'react-router-dom'
import cssclass from "./cssclass";
//var dateFormat = require('dateformat');


/*
SELECT  *  FROM WPT_PERSON WHERE IMG_REF='H2624'
*/	



const RenderWpForm = () => {

const aftertriggerselect = (name, value) => {
	console.log('aftertriggerselect: '+name);
	return '';
	
}

const resturl=sessionStorage.getItem("RESTURL");
//var boolFetchingSads=false;

const navigate = useNavigate();

window.addEventListener("keypress", function (event) {
 // detect event keys
 if (event.keyCode == 13) {
   //callsadfinder();
   
 }
});


const navWptform = React.useRef();
const [linkwpform, setLinkwpform] = useState({WPT_APP_ID:0});
const [nextpg, setNextpg] = useState({name:"wptform"});

const [wptapp, setWptapp] = useState({WPT_APP_ID:null
, REF_NUM:null
, APP_TYPE_ID:''
, TC_ISLAND:''
, CASE_WORKER:''
, PROCESS_AREA:''
});




//const [lsimgref, setLsimgref] = useState([]);
const [emplids, setEmplids] = useState([]);
//const [combompenames, setCombompenames] = useState([]);
const [tblmpenamelookup, setTblmpenamelookup] = useState([]);
const [myprofile, setMyprofile] = useState({});


//const [currdiv, setCurrdiv] = useState({name:'mpr'});
const [mpe, setMpe] = useState({
IMG_REF:''
, DOB:''
, FIRST_NAME:''
, HLD_PVS_WPT:''
, SKIP_IMG_REF_LOOKUP:false
, IMG_REF_TIP:false
, LOOKUP_ID_TBL: ""
, LOOKUP_ID_NBR: 0
});
const [mpr, setMpr] = useState({
	EMPL_ID:''
	, GOVT:0
	, COMPANY:''
	});




const [combofirstlaborcltype, setCombofirstlaborcltype] = useState([]);
const [combolaborcltype, setCombolaborcltype] = useState([]);
const [combolocation, setCombolocation] = useState([]);
const [comboprocessarea, setComboprocessarea] = useState([]);
const [comboprocessareacopy, setComboprocessareacopy] = useState([]);


const [visibformfields, setVisibformfields] = useState({
	mpename:false
	});
	
const [dowait, setDowait] = useState({show: false});
const [progress, setProgress] = useState({
perct:null
});


const location = useLocation();


useEffect(() => {
	
if (sessionStorage.getItem("USERNAME")==null || sessionStorage.getItem("USERNAME")=="null" || sessionStorage.getItem("USERNAME")==undefined || sessionStorage.getItem("USERNAME")==""){
	navigate("/");
	return;
	}//end if	
	
document.title =   "APS New Application";	
if (document.getElementById('cbmprdone'))
	document.getElementById('cbmprdone').disabled=true;

getwpformoptions();



 },[]);



useEffect(() => {
	cssclass("tblmpenamelookup", "hidden", tblmpenamelookup.length==0?1:0);
 },[tblmpenamelookup.length]);
 
 
useEffect(() => {
	if (comboprocessarea.length>0)
		getloginprofile();
 },[JSON.stringify(comboprocessarea)]);


useEffect(() => {
		
		if (combolocation.length>0){
			const e={target:{value:""}};
			getemployers(e, 1);
			}//end if
		
 },[mpr.GOVT]);





useEffect(() => {
/*
when user upload foto get refnum first
after refnum is set then upload foto
*/
//console.log('useEffect wptapp: '+JSON.stringify(wptapp));
	

	if (wptapp.WPT_APP_ID!=null){
		const AD_USER=sessionStorage.getItem("AD_USER");
		navWptform.current?.click();

/*
		if (AD_USER=="")
			navWptform.current?.click();
		else
			navigate("/lbr_clr_app", {state:{WPT_APP_ID:wptapp.WPT_APP_ID}});

*/
			
		//navigate("/lbr_clr_app", {state:{WPT_APP_ID:wptapp.WPT_APP_ID}});
		//"/startlcrapp"
		}//end if 
		
	
 },[wptapp]);












useEffect(() => {

if (document.getElementsByName('IMG_REF')[0]){
	toggleAllowImgRef(!mpe.SKIP_IMG_REF_LOOKUP);
	}//end if

 },[mpe.SKIP_IMG_REF_LOOKUP]);
 







async function getwpformoptions(){

   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( )
  };		

 await fetch(resturl+'rarwpform/getwpformoptions',requestOptions)
      .then(res => res.json())
      .then(res => 	aftergetwpformoptions(res) )
      .catch(err => console.log(err));

}//end func




function aftergetwpformoptions(res){
let tempfirstlaborcltype=[];
let templaborcltype=[];
//Fast Track
let templocation=[];
let tempprocessarea=[];

res.map((col, index) => {
	const combo=col['COMBO'];
	const key=combo+"_"+index;
	const key2=combo+"_"+index+"_2";
	const opt=col['OPT'];
	const val=col['VAL'];
	const strOption=""+opt;

	if (combo=='laborcltype'){
		
		if (strOption.toUpperCase().includes("FIRST TIME"))
			tempfirstlaborcltype.push(<option key={key} value={val}  >{opt}</option>);
		else
			templaborcltype.push(<option key={key} value={val}  >{opt}</option>);
		}//end if
	else if (combo=='location' && !strOption.toUpperCase().includes("UNKNOWN"))
		templocation.push(<option key={key} value={opt}  >{opt}</option>);
	else if (combo=='processarea')
		tempprocessarea.push(<option key={key} value={opt}  >{opt}</option>);
	
	});//end map
setCombofirstlaborcltype(tempfirstlaborcltype);
setCombolaborcltype(templaborcltype);
setCombolocation(templocation);
setComboprocessareacopy(tempprocessarea);
setComboprocessarea(tempprocessarea);
document.getElementsByName('COMPANY')[0].focus();	
/*
firstlaborcltype - First time
laborcltype - all except First time
*/

}//end func



async function findwptorpersonbyrefnum(IMG_REF){


   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( {IMG_REF:IMG_REF} )
  };		

setTblmpenamelookup([]);
setMpe((prev)=>{
	return {
		...prev
	, LOOKUP_ID_TBL: ""
	, LOOKUP_ID_NBR: 0
	}
	});

 await fetch(resturl+'rarwpform/findwptorpersonbyrefnum',requestOptions)
      .then(res => res.json())
      .then(res => 	afterfindwptorpersonbyrefnum(res) )
      .catch(err => console.log(err));

}//end func

function afterfindwptorpersonbyrefnum(res){

document.getElementById("trlookup").style.visibility="visible";

if (!res.length){
	return;
	}//end if

let htmrows=[];

res.map((col, index) => {
	const key="tr_mpename_"+index;
	const radioId="rd_mpename_"+index;
	const htmrow=<tr>
		<td align="right" >{index+1}</td>
		<td align="center" >{col['GENDER']}</td>
		<td align="left" >{col['FIRST_NAME']}</td>
		<td align="left" >{col['LAST_NAME']}</td>
		<td align="left" >{col['EMPLOYER']??""}</td>
		<td align="center" >{col['EXPIRE_DATE']??""}</td>
		<td align="center" ><input type="radio" name="rdmpename" id={radioId} onClick={(e)=>{clickRdmpename(e, col)}} /><label htmlFor={radioId} className="hand" >{col['TC_DOB']}</label></td>
		</tr>;
	
	htmrows.push(htmrow);
	});//end map


setTblmpenamelookup(htmrows);


}//end func

function clickRdmpename(e, col){
/*
let LOOKUP_ID_TBL="WORK_PERMIT";
let LOOKUP_ID_NBR=col.WORK_PERMIT_ID??0;
if (LOOKUP_ID_NBR==0){
	LOOKUP_ID_NBR=col.PERSON_ID??0;
	LOOKUP_ID_TBL="PERSON";
	}//end if
*/
	
setMpe((prev)=>{
	return {
		...prev
	, LOOKUP_ID_TBL: col.LOOKUP_ID_TBL
	, LOOKUP_ID_NBR: col.LOOKUP_ID_NBR
	}
	});
}//end func




function clickGovt(e){
	
	const Govt=e.target.checked==true?1:0;
	
	setMpr((prev)=>{
		return {...prev, GOVT:Govt, EMPL_ID:"", COMPANY:""}
		});

	const pgname=Govt==1?"gvtform":"wptform";
	setNextpg({name:pgname});

	if (Govt==1)
		setComboprocessarea([<option key="processareaGovt" value="Government"  >Government</option>]);
	else
		setComboprocessarea(comboprocessareacopy);

}//end func

async function getemployers(e, includeEmptyMpr){

setMpr((prev)=>{
	return {...prev, COMPANY:e.target.value}
	});

	const strCompany = (""+e.target.value).trim();

	//console.log('getemployers strCompany.length: '+strCompany.length);
	console.log('getemployers mpr.GOVT: '+mpr.GOVT);
	
	if (strCompany.length<3 && mpr.GOVT==0){// && mpr.GOVT==0
		($( "#COMPANY" )).autocomplete({source: []});
		document.getElementById('cbmprdone').disabled=true;
		return;
		}//end if
		
	if (strCompany.length<3)
		document.getElementById('cbmprdone').disabled=true;
	else
		document.getElementById('cbmprdone').disabled=false;

   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( {MPE_OR_MPR:"companyname", crit:strCompany, GOVT:mpr.GOVT} )
  };		

 await fetch(resturl+'rarwpform/getemployers',requestOptions)
      .then(res => res.json())
      .then(res => 	aftergetemployers(res) )
      .catch(err => console.log(err));

}//end func



function aftergetemployers(res){
//document.getElementById('cbmprdone').disabled=false;

let arrCmp=[];
let arrEMPL_ID=[];
	
res.map((col, index) => {
			arrCmp.push(col['COMPANY']);
			const key="emplid_"+index+"_";
			arrEMPL_ID.push(<>
					<input name='HDN_EMPL_ID[]' key={key+"a"} value={col['EMPL_ID']} type='hidden' />
					<input name='HDN_COMPANY[]' key={key+"b"} value={col['COMPANY']} type='hidden' />
					</>
					);
			});
	
	console.log('arrCmp.length: '+arrCmp.length);
	setEmplids(arrEMPL_ID);
    ($( "#COMPANY" )).autocomplete({source: arrCmp});   
  

  $('#COMPANY').autocomplete('search', '');
  document.getElementsByName('COMPANY')[0].focus();	
}//end func	









async function createwptapp(e){
	
	e.preventDefault();
	
	cssclass("btnproceed", "hidden", 1);
	
	console.log('createwptapp: '+JSON.stringify(wptapp));
	const params={
		mpr:mpr
		, mpe:mpe
		, wptapp: wptapp
		, mpedobandname: ""
		, username:sessionStorage.getItem("USERNAME")
			}
	//document.getElementsByName("combompenames")[0].value
   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( params )
  };		
	
	setDowait({show:true});
	
  await fetch(resturl+'rarwpform/createwptapp',requestOptions)
      .then(res => res.json())
      .then(res => 	aftercreatewptapp(res) )
      .catch(err => console.log(err));
}//end func

function aftercreatewptapp(res){
setDowait({show:false});

const WPT_APP_ID=res.length?(res[0].WPT_APP_ID??0):0;

if (WPT_APP_ID==0)
	showsnackbar(res.error);
else
	setWptapp((prev)=>{
		return {...prev, WPT_APP_ID:WPT_APP_ID}		
	});	
	
}//end func


function handleImgRefChange(imgRef, isblur){

if (mpe.SKIP_IMG_REF_LOOKUP==true)
	return;

const strImgRef=(""+imgRef).trim();
if (strImgRef.length<4)
	setTblmpenamelookup([]);
else
	findwptorpersonbyrefnum(strImgRef, isblur);
}//end func




function callsetMpe(e){
	let {name, value}=e.target;
	//console.log('callsetMpe name: '+name);
	value=value.trim();

setMpe((prev) => {
return {...prev, [name]:value}
});

if (name=="IMG_REF"){
	
	setTblmpenamelookup([]);
	let IMG_REF_TIP=false;
	
	if (value.length>1){
		const letter=value.trim().substring(0,1).toUpperCase();
		const num=value.trim().substring(1,1);
		if ('ABCDEFGHIJKLMNOPQRSTUVWXYZ'.includes(letter) && '0123456789'.includes(num))
			IMG_REF_TIP=true;
		}//end if
	else
		IMG_REF_TIP=false;

	setMpe((prev) => {
		return {...prev, DOB:'', FIRST_NAME:'', IMG_REF_TIP:IMG_REF_TIP, SKIP_IMG_REF_LOOKUP:false}
		});	
	}//end if

if (name=="HLD_PVS_WPT"){
	
	let fasttrackmsgVsb = 'hidden', ImgRefRqd = false, APP_TYPE_ID="3";
	if (value==1){
		fasttrackmsgVsb = 'visible';
		ImgRefRqd = true;
		APP_TYPE_ID = "";
		}//end if
	document.getElementById('fasttrackmsg').style.visibility=fasttrackmsgVsb;
	/* IMG_REF input rqd if held previous wpt is true */
	

	toggleAllowImgRef(ImgRefRqd);
	/*
	note the below call is to setWptapp, not to setMpe
	setMpe is called in toggleAllowImgRef
	*/
	let LOOKUP_ID_NBR=0;
	if (value=="")
		LOOKUP_ID_NBR=0;
	else if (value==1)
		LOOKUP_ID_NBR=0;
	else if (value==0)
		LOOKUP_ID_NBR=1;
	//the previous work permit can be used to set defaults on section A and Work History also
	setMpe((prev) => {
	return {...prev, LOOKUP_ID_NBR:LOOKUP_ID_NBR}
	});	
	
	setWptapp((prev)=>{
		return {...prev, APP_TYPE_ID:APP_TYPE_ID}
		});

	}//end if
	
}//end func


function toggleAllowImgRef(ImgRefRqd){

const elImgRef=document.getElementsByName('IMG_REF')[0];

if (ImgRefRqd==true){
	elImgRef.required=true;
	elImgRef.readOnly=false;
	if (elImgRef.classList.contains("gnsbro"))
		elImgRef.classList.remove("gnsbro");
	}//end if
else{
	setMpe((prev)=>{
		return {...prev, IMG_REF:""}
		});
		
	elImgRef.required=false;
	elImgRef.readOnly=true;
	if (!elImgRef.classList.contains("gnsbro"))
		elImgRef.classList.add("gnsbro");

	const HLD_PVS_WPT=document.getElementsByName('HLD_PVS_WPT')[0].value;
	if (HLD_PVS_WPT==0||HLD_PVS_WPT==''){
		
		setTblmpenamelookup([]);
		//turn off SKIP_IMG_REF_LOOKUP to remove the errr message
		setMpe((prev)=>{
			return {...prev, IMG_REF:"", SKIP_IMG_REF_LOOKUP:false}
			});		
		}//end if
	}//end else
	
}//end func

function clickNoimgref(e){
if (e.target.checked){
	document.getElementById('IMG_REF').value='';
	document.getElementById('IMG_REF').readOnly=true;
	document.getElementById('IMG_REF').classList.add("gnsbro");
	}
else{
	document.getElementById('IMG_REF').readOnly=false;
	document.getElementById('IMG_REF').classList.remove("gnsbro");
	}	
	
	setVisibformfields((prev)=>{
		return {...prev, mpefoto:e.target.checked}
	});
	
	
}//end func

function clickCbmprdone(e){
if (e.target.checked){
	document.getElementById('cbmprdone').disabled=true;
	document.getElementById('cbgvt').disabled=true;
	document.getElementById('COMPANY').readOnly=true;
	document.getElementById('COMPANY').classList.add("gnsbro");
	setMpr((prev)=>{
		const COMPANY = document.getElementById('COMPANY').value;
		const EMPL_ID = document.getElementById('EMPL_ID').value;
		return {...prev, COMPANY:COMPANY, EMPL_ID:EMPL_ID}
		});
	}//end if
else{
	document.getElementById('cbgvt').disabled=false;
	document.getElementById('COMPANY').readOnly=false;
	document.getElementById('COMPANY').classList.remove("gnsbro");
	document.getElementById('COMPANY').focus();
	}

setVisibformfields((prev)=>{
	return {...prev, mpename:e.target.checked}
	});

}//end func




function callsetWptapp(e){
	const [attribNam, attribVal]=[e.target.name, e.target.value];
	console.log('callsetWptapp attribNam: '+attribNam);
setWptapp((prev) => {
return {...prev, [attribNam]:attribVal}
});

if (attribNam=='TC_ISLAND')
	document.getElementsByName('IMG_REF')[0].focus();

}//end func

function showsnackbar(innerHTML) {
  var x = document.getElementById("snackbar");
  x.innerHTML=innerHTML;
  x.className = "show";
  setTimeout(function(){ x.className = x.className.replace("show", ""); }, 2500);
}//end func

function nofunc(e){
}//end func



function getloginprofile(){
	
   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( {USERNAME:sessionStorage.getItem("USERNAME")} )
  };	
	
  fetch(resturl+'rarwpform/getloginprofile',requestOptions)
      .then(res => res.json())
      .then(res => 	aftergetloginprofile(res) )
      .catch(err => console.log(err));

	//console.log('aftergetwpapp: '+res[0].OCCUPATION);
}//end func

function aftergetloginprofile(res){
//const IRD_LOGIN_ID=(res.length>0)?res[0].IRD_LOGIN_ID:'';
//console.log('aftergetloginprofile: '+JSON.stringify(res[0]));
if (res.length>0){
		setMyprofile((prev)=>{
		return {...prev
		, EMPL_COMPANY:res[0].EMPL_COMPANY
		, CASE_WORKER:res[0].CASE_WORKER
		, FULLNAME:res[0].FULLNAME
		, EMAIL:res[0].EMAIL
		, USERNAME:res[0].USERNAME
		, PROCESS_AREA:res[0].PROCESS_AREA
		, TC_ISLAND:res[0].TC_ISLAND
		}
		});
		setWptapp((prev)=>{
		return {...prev
		, CASE_WORKER:res[0].CASE_WORKER
		}
		});		
		
	}//end if

}//end func

function clickImgrefMsg(e){
	e.preventDefault();
	alert("If your Immigration Ref does not work, please email a copy of\r\nthe work permit card to system admin, to add to the lookup");
}//end func

function userdefault(arg){
	if (arg=='PROCESS_AREA' && mpr.GOVT==1){
		console.log("abort userdefault");
		return;
		}
		
		
	let value=myprofile[arg];
	if (value==null)
		value="";
	console.log("userdefault: "+value);
	if (value=="")
		showsnackbar("this default can be set on My Profile page");
	else
		setWptapp((prev)=>{
			return {...prev, [arg]:value}
		})
}//end func

const refNum=(wptapp.REF_NUM==null)?"":wptapp.REF_NUM;

	
  return (
    <>

<fieldset className='fieldsetlg' style={{width:"75%",marginTop:"30px"}} >
<legend onClick={(e)=>{console.log("wptapp: "+JSON.stringify(wptapp));}} >Turks & Caicos Work Permit Application {wptapp.REF_NUM}</legend>
<form method='POST' id='form1' onSubmit={(e)=>{createwptapp(e);}}  >
<table align='center' style={{marginTop:"10px", marginBottom:"10px"}} >	
<tbody>

	<tr>
		<td align='center' colSpan="2" >
		<input type='checkbox' id='cbmprdone' onClick={(e)=>{clickCbmprdone(e);}}  /><label htmlFor='cbmprdone' className="hand" >tick here when done entering employer's name</label>
		</td>
	</tr>
	<tr>
		<td align='right' >Employer's name:</td>
		<td align='left' ><input name='COMPANY' id='COMPANY' size='38' required value={mpr.COMPANY} onChange={(e)=>{getemployers(e, 0);}} autoComplete="off" onFocus={(e)=>{e.target.select();}} placeholder="enter employer's name" /></td>
	</tr>
	<tr>
		<td align='right' >Employer's id:</td>
		<td align='left' >
		<input name='EMPL_ID' size='5' id='EMPL_ID' value={mpr.EMPL_ID} className="gnsbro"  readOnly />
		&nbsp;&nbsp;
		<input type='checkbox' id='cbgvt' onClick={(e)=>{clickGovt(e);}} />
		<label htmlFor='cbgvt' className="hand" >Employer is Government</label>
	
		</td>
	</tr>

	{
	visibformfields.mpename && 
	<>
	<tr>
		<td align='right' >The applicant had a TCI Work Permit Card before?</td>
		<td align='left' >
			<select name='HLD_PVS_WPT' required onChange={ (e)=>{callsetMpe(e);} } >
			<option value='' ></option>
			<option value='1' >Yes</option>
			<option value='0' >No</option>
			</select>
		</td>
	</tr>	
	<tr>
		<td align='right' >Processing Area:</td>
		<td align='left' >
			<select name='PROCESS_AREA' required value={wptapp.PROCESS_AREA} onChange={ (e)=>{callsetWptapp(e);} } style={{width:"180px"}} >
			<option value='' ></option>
			{comboprocessarea}
			</select>
			&nbsp;<input type='checkbox' id='defaultpra' onClick={(e)=>{userdefault('PROCESS_AREA');}}  title='this default can be set on your profile page' />
			<label htmlFor='defaultpra' className="hand" >default</label>
		</td>
	</tr>		
	<tr>
		<td align='right' >Type of Application:</td>
		<td align='left' >
			<select name='APP_TYPE_ID' required value={wptapp.APP_TYPE_ID} onChange={ (e)=>{callsetWptapp(e);} } style={{width:"180px"}} >
			<option value='' ></option>
			{mpe.HLD_PVS_WPT=='1' && combolaborcltype}
			{mpe.HLD_PVS_WPT=='0' && combofirstlaborcltype}
			</select>
			&nbsp;&nbsp;<span id='fasttrackmsg' style={{visibility:"hidden"}} >(Fast Track may require $650 payment)</span>
		</td>
	</tr>		

	<tr>
		<td align='right' >Location of the Job:</td>
		<td align='left' >
			<select name='TC_ISLAND' required  value={wptapp.TC_ISLAND} onChange={ (e)=>{callsetWptapp(e);} } >
			<option value='' ></option>
			{combolocation}
			</select>
			&nbsp;<input type='checkbox' id='defaultloc' onClick={(e)=>{userdefault('TC_ISLAND');}} title='this default can be set on your profile page' />
			<label htmlFor='defaultloc' className="hand" >default</label>
		</td>
	</tr>	
	<tr>
		<td align='right' >Applicant's Immigration reference #:</td>
		<td align='left' >
			<input name='IMG_REF' id='IMG_REF' required value={mpe.IMG_REF} onChange={(e)=>{callsetMpe(e);}} onBlur={(e)=>{handleImgRefChange(e.target.value,1);}} autoComplete="off" onFocus={(e)=>{e.target.select();}} placeholder="Applicant's Immigration ref #" />
			&nbsp;{mpe.IMG_REF_TIP==true && <>(hit tab key on keyboard when done)</>}
		</td>
	</tr>
			{
			mpe.LOOKUP_ID_NBR>0 && 
			<tr>
			<td align='right' ></td>
			<td align='left' ><button id="btnproceed" className="button" >proceed to application form</button></td>
			</tr>
			
			}
	
	<tr id='trlookup' style={{visibility:"hidden"}} >
		<td align='center' colSpan="2" >
		<div align="center" >Applicant's DOB & Name Lookup:  <span className="brown" >Choose the correct name and expiration date</span></div>
		<table align="center" id="tblmpenamelookup" className="customers" >
			<thead>
			<tr>
			<th align='left' ></th>
			<th align='center' >Gender</th>
			<th align='left' >First Name</th>
			<th align='left' >Last Name</th>
			<th align='left' >Last Work Permit<br/>Employer Name</th>
			<th align='center' >Last Work Permit<br/>Expiration Date</th>
			<th align='center' >Date Of Birth</th>
			</tr>
			</thead>
			<tbody>
			{tblmpenamelookup}
			</tbody>
		</table>
		</td>
	</tr>
	{
		mpe.SKIP_IMG_REF_LOOKUP==true && 
		<tr>
		<td align="center" colSpan="2" style={{color:"brown"}} ><a href="#" onClick={(e)=>{clickImgrefMsg(e);}} ><img src="img/error.png" border="0" /></a>&nbsp;this work permit application may suffer delays due to absence of Immigration Ref. #</td>
		</tr>
	}
	


	</>
	}

			
			</tbody>
			</table>
			

			</form>
			{emplids}
	
	
</fieldset>

          <NavLink
		  ref={navWptform}
          to={"/"+nextpg.name}
		  style={{display:"none"}}
          state={{
		  WPT_APP_ID:wptapp.WPT_APP_ID
		  }} 
        >
		&nbsp;click here to wpform
        </NavLink>

<div id="snackbar">&nbsp;</div>

    </>
  );
  


};


export default RenderWpForm;